export default "__VITE_ASSET__BzKArINk__"